<template>
	<div class="nav_list">
		<a :href="title" @click.prevent="change(title)" :class="{'router-link-active' : sportValue === title}" v-for="(item, title) in items" :key="title">
			{{ item }}
		</a>
	</div>
</template>

<script>
	export default {
		props: ['sport'],
		
		data() {
			return {
				items: {
					'': 'Все',
					cs: 'CS',
					overwatch: 'Overwatch',
					dota: 'Dota',
				},
				sportValue: this.sport || ''
			}
		},
		methods: {
			change(value) {
				this.$emit('update', value);
			}
		},
	}
</script>

<style scoped>

</style>